import { getNewAuthToken, isTokenExpired } from "../utils";
import { baseURL } from "../utils/url";
import { GET_BUSINESS_GOAL, CLEAR_BUSINESS_GOAL } from "./type";

export const getBusinessGoal = (token) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "businessgoal", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        fetchResponse
            .json()
            .then((res) => {
                if (res.length >= 0) {
                    dispatch({
                        type: GET_BUSINESS_GOAL,
                        payload: res,
                    });
                    return res;
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const clearBusinessGoal = () => async (dispatch) => {
    dispatch({ type: CLEAR_BUSINESS_GOAL });
};
